import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Button } from '@components/shared/Button'

export const Container = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-top: 40px;
    padding: 24px 24px 24px 22px;
    border-radius: 12px;
    border: 1px solid ${theme.colors.border.light};
    background: ${theme.colors.lightest};
    box-shadow: 4px 4px 8px 0 ${theme.colors.background.hover};
  `}
`

export const Info = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const IconBox = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 8px;
    color: ${theme.colors.primary};
    background: ${theme.colors.gray.light};
    flex-shrink: 0;
  `}
`

export const Title = styled(Box)`
  ${({ theme }) => css`
    font-size: 18px;
    font-weight: 600;
    color: ${theme.colors.secondary};
  `}
`

export const Description = styled(Box)`
  ${({ theme }) => css`
    font-size: 14px;
    color: ${theme.colors.secondary};
  `}
`

export const HistoryButton = styled(Button)`
  ${({ theme }) => css`
    transition: background-color 0.2s ease;

    &&:hover {
      background: ${theme.colors.secondary};
    }
  `}
`
